import React, { useContext } from "react";
import PropTypes from "prop-types";

import { Numeric } from "rbx";

import { ModalContext } from "../../../../components/ModalProvider";

import "./NextCertificationExp.scss";

import CertificationModal from "./CertificationModal";

const getStyles = value => {
  const styles = {
    backgroundColor: "LIMEGREEN",
    color: "black"
  };

  if (value <= 0) {
    styles.backgroundColor = "CRIMSON";
  } else if (value <= 30) {
    styles.backgroundColor = "ORANGERED";
  } else if (value <= 45) {
    styles.backgroundColor = "ORANGE";
  } else if (value <= 60) {
    styles.backgroundColor = "YELLOW";
    styles.color = "black";
  }
  return styles;
};

const NextCertificationExp = ({ cell, row, pickupDate }) => {
  const { setModalOpen } = useContext(ModalContext);

  const styles = getStyles(cell.value);

  const handleClick = async () => {
    try {
      setModalOpen(
        true,
        <CertificationModal
          employeeRecIdRef={row.original.EmployeeRecIdRef}
          pickupDate={pickupDate}
        />
      );
    } catch (err) {
      console.log(err.message);
    }
  };
  return (
    <div className="next-cert-exp-tag">
      <Numeric style={styles} onClick={handleClick}>
        <b>{cell.value}</b>
      </Numeric>
    </div>
  );
};

NextCertificationExp.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  pickupDate: PropTypes.string
};
export default NextCertificationExp;
